import { faPen, faPlus } from "@fortawesome/free-solid-svg-icons";
import { useState } from "react";
import { Breadcrumb } from "react-bootstrap";
import Col from "react-bootstrap/esm/Col";
import Container from "react-bootstrap/esm/Container";
import Row from "react-bootstrap/esm/Row";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import { ColumnRender, FilterType, IColumn, IFilter, IPagedListAction } from "../../components/PagedList/Declarations";
import { PagedList } from "../../components/PagedList/PagedList";
import { IProductCategory } from "../../customTypings/ProductCategory";
import { productCategoryService } from "../../services";
import { ProductCategoryAddPage } from "./ProductCategoryAddPage";
import { ProductCategoryEditPage } from "./ProductCategoryEditPage";

const ProductCategoryListPage = () => {

    const [showEditProductCategory, setShowEditProductCategory] = useState(false);
    const [showAddProductCategory, setShowAddProductCategory] = useState(false);
    const [refreshNumber, setRefeshNumber] = useState(0);
    const [productCategory, setProductCategory] = useState<IProductCategory>();

    const getProductCategory = (id: string) => {
        productCategoryService.get(id).then((res) => {
            setProductCategory(res);
        });
    };

    const handleAddProductCategory = (added: boolean) => {
        if (added) {
            setRefeshNumber((refreshNumber) => refreshNumber + 1);
        }
        setShowAddProductCategory(false);
    };

    const handleOpenAddProductCategory = () => {
        setShowAddProductCategory(true);
    };

    const handleEdit = (updated: boolean) => {
        if (updated) {
            setRefeshNumber(refreshNumber + 1);
        }
        setShowEditProductCategory(false);
    };

    return (
        <>
            <Container fluid>
                <Row>
                    <Col>
                        <Helmet>
                            <title>Product Categories</title>
                        </Helmet>

                        <Breadcrumb>
                            <Breadcrumb.Item linkAs={Link} linkProps={{ to: "/settings" }}>
                                Settings
                            </Breadcrumb.Item>
                            <Breadcrumb.Item active>Product Categories</Breadcrumb.Item>
                        </Breadcrumb>

                        <h1 className="my-3">Product Categories</h1>
                        <PagedList
                            columns={[
                                {
                                    member: "name",
                                    renderAs: ColumnRender.text,
                                    title: "Name",
                                    width: 200,
                                } as IColumn,
                            ]}
                            itemActions={[
                                {
                                    icon: faPen,
                                    text: "Edit",
                                    onClick: (item) => {
                                        getProductCategory(item.id);
                                        setShowEditProductCategory(true);
                                    },
                                } as IPagedListAction,
                            ]}
                            headActions={[
                                {
                                    icon: faPlus,
                                    text: "Add Product Category",
                                    onClick: handleOpenAddProductCategory,
                                } as IPagedListAction,
                            ]}
                            filters={[
                                {
                                    title: "Name",
                                    member: "name",
                                    type: FilterType.text,
                                } as IFilter,
                            ]}
                            defaultSortBy="name"
                            getUrl="api/productcategory/all" // Adjust this endpoint based on your API
                            avatarUrl="api/avatar/get" // Adjust if applicable
                            refreshNumber={refreshNumber + 1}
                            rowFormatter={(item: any) => {
                                return null; // Modify row formatter as per your requirement
                            }}
                            persistanceKey="ProductCategoryListPage"
                        />
                    </Col>
                </Row>
            </Container>
            <ProductCategoryAddPage show={showAddProductCategory} onClose={handleAddProductCategory} />
            <ProductCategoryEditPage show={showEditProductCategory} onClose={handleEdit} currentCategory={productCategory} />
        </>
    );
};

export { ProductCategoryListPage };
